import { FC } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import style from './audit-log.module.scss';

export const Markdown: FC<{ text: string }> = ({ text }) => (
  <div className={style.markdown}>
    <ReactMarkdown remarkPlugins={[remarkGfm]}>{text}</ReactMarkdown>
  </div>
);
